/* Casa Lizette — product gallery: thumbnail swap + swipe, and variant option -> media/price sync. */
(function () {
  'use strict';

  function initGallery(gallery) {
    var slides = gallery.querySelectorAll('[data-gallery-slide]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    var prevBtn = gallery.querySelector('[data-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-gallery-next]');
    var current = 0;

    function goTo(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
      current = index;
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        goTo(parseInt(thumb.getAttribute('data-index'), 10));
      });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    // Basic touch swipe on mobile.
    var main = gallery.querySelector('[data-gallery-main]');
    if (main) {
      var startX = null;
      main.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var deltaX = e.changedTouches[0].clientX - startX;
        if (Math.abs(deltaX) > 40) goTo(deltaX > 0 ? current - 1 : current + 1);
        startX = null;
      }, { passive: true });
    }
  }

  function initVariantSync(form) {
    var selects = form.querySelectorAll('[data-product-option-select]');
    var variantIdInput = form.querySelector('[data-product-variant-id]');
    var variantsJsonEl = form.closest('[data-product-buy-box]');
    if (!variantsJsonEl) return;
    var scriptEl = variantsJsonEl.querySelector('[data-product-variants-json]');
    if (!scriptEl) return;
    var variants;
    try { variants = JSON.parse(scriptEl.textContent); } catch (e) { return; }

    function currentSelection() {
      return Array.prototype.map.call(selects, function (s) { return s.value; });
    }

    function findVariant(selection) {
      return variants.find(function (v) {
        var options = [v.option1, v.option2, v.option3].filter(function (o) { return o !== null; });
        return options.every(function (opt, i) { return opt === selection[i]; });
      });
    }

    function updateForSelection() {
      var variant = findVariant(currentSelection());
      if (!variant) return;
      if (variantIdInput) variantIdInput.value = variant.id;

      var priceEls = document.querySelectorAll('[data-price]');
      priceEls.forEach(function (el) {
        el.textContent = (variant.price / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
      });

      document.dispatchEvent(new CustomEvent('casa-lizette:variant-change', { detail: { price: variant.price, variantId: variant.id } }));
    }

    selects.forEach(function (select) {
      select.addEventListener('change', updateForSelection);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-product-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-product-form]').forEach(initVariantSync);

    // Quantity steppers on the product buy box.
    document.querySelectorAll('.qty-stepper').forEach(function (stepper) {
      var input = stepper.querySelector('input[type="number"]');
      var decrease = stepper.querySelector('[data-qty-decrease]');
      var increase = stepper.querySelector('[data-qty-increase]');
      if (!input) return;
      if (decrease) decrease.addEventListener('click', function () {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      });
      if (increase) increase.addEventListener('click', function () {
        input.value = (parseInt(input.value, 10) || 1) + 1;
      });
    });
  });
})();
